module.exports = __webpack_public_path__ + "img/getboarded.92333ab3.svg";